export const PERIOD_TYPES_OPTIONS = {
  date: 'Daily',
  datetime: 'Hourly'
};
